import {
  UPDATE_PHONE_ID,
  SWAP_LANGUAGE,
  FETCH_USER,
  FETCH_OPTIONS,
  FETCH_CUSTOMER_LABELS
} from './constants'

export const updatePhoneId = (phoneId, deviceName) => ({
  type: UPDATE_PHONE_ID,
  deviceName,
  phoneId
})

export const swapLanguage = (language) => ({ type: SWAP_LANGUAGE, language })

export const fetchUser = {
  request: (auth) => ({ type: FETCH_USER.REQUEST, auth }),
  success: (user) => ({ type: FETCH_USER.SUCCESS, user })
}

export const fetchOptions = {
  request: () => ({ type: FETCH_OPTIONS.REQUEST }),
  success: (options) => ({ type: FETCH_OPTIONS.SUCCESS, options })
}

export const fetchCustomerLabels = {
  request: () => ({ type: FETCH_CUSTOMER_LABELS.REQUEST }),
  success: (customerLabels) => ({
    type: FETCH_CUSTOMER_LABELS.SUCCESS,
    customerLabels
  })
}
